/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import { MediaBatchData } from "../../../types/mediaBatchCommon.types";

interface Props {
	onBack: () => void;
	targetTemp?: string;
	equimentRef?: string;
	mediaBatchData: MediaBatchData | null;
}

const MBSterilizationHeader = ({ onBack, targetTemp, equimentRef, mediaBatchData }: Props) => {
	const { t } = useTranslation();

	return (
		<div className="bg-white px-8 py-2 shrink-0 border-b border-slate-100 shadow-sm">
        <div className="flex items-center gap-6 mb-2">
          <button onClick={onBack} className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-400 hover:text-orange-500 hover:bg-orange-50 transition-all">
            <span className="material-symbols-outlined text-xl">arrow_back</span>
          </button>
          <div className="flex items-center gap-10">
            <h2 className="text-xl font-black text-[#2D3E50] tracking-tight">{t("mediaBatchInit.sterilization.mediaSterilization")}</h2>
            <div className="flex items-center gap-3">
              <div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
                <span className="material-symbols-outlined text-xs font-black">{t("mediaBatchInit.finalQuality.check")}</span>
              </div>
              <div className="w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center">
                <span className="material-symbols-outlined text-xs font-black">{t("mediaBatchInit.finalQuality.check")}</span>
              </div>
              <div className="w-7 h-7 rounded-full bg-[#2D3E50] text-white flex items-center justify-center text-[10px] font-black ring-4 ring-slate-100">3</div>
              <div className="w-7 h-7 rounded-full bg-slate-100 text-slate-300 flex items-center justify-center text-[10px] font-black">4</div>
              <div className="w-7 h-7 rounded-full bg-slate-100 text-slate-300 flex items-center justify-center text-[10px] font-black">5</div>
              <div className="w-7 h-7 rounded-full bg-slate-100 text-slate-300 flex items-center justify-center text-[10px] font-black">6</div>

              <div className="ml-6 flex flex-col">
                <span className="text-[7px] font-black text-orange-500 uppercase tracking-[0.2em] leading-none">{t("mediaBatchInit.sterilization.activePhase")}</span>
                <span className="text-[9px] font-black text-[#2D3E50] uppercase tracking-wider">{t("mediaBatchInit.sterilization.thermalSterilizationCycle")}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Batch Info Sub-Header */}
        <div className="flex items-center justify-between border-t border-slate-50 pt-4 pb-2">
          <div className="flex gap-10">
            <div className="space-y-0.5">
              <p className="text-[8px] font-black text-slate-400 uppercase tracking-widest leading-none">{t("mediaBatchInit.sterilization.mediaType")}</p>
						<p className="text-[11px] font-black text-[#2D3E50]">{mediaBatchData?.media_type }</p>
            </div>
            <div className="space-y-0.5">
              <p className="text-[8px] font-black text-slate-400 uppercase tracking-widest leading-none">{t("mediaBatchInit.sterilization.batchId")}</p>
						<p className="text-[11px] font-black text-[#2D3E50]">{mediaBatchData?.media_batch_identifier}</p>
            </div>
            <div className="space-y-0.5 text-center">
              <p className="text-[8px] font-black text-slate-400 uppercase tracking-widest leading-none">{t("mediaBatchInit.sterilization.targetTemp")}</p>
						<p className="text-[11px] font-black text-emerald-600">{targetTemp}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right space-y-0.5">
						<p className="text-[8px] font-black text-slate-400 uppercase tracking-widest leading-none">{t("mediaBatchInit.sterilization.equipmentReference")}</p>
						<p className="text-[11px] font-black text-[#2D3E50]">{equimentRef}</p>
            </div>
            <button className="bg-[#2D3E50] text-white w-8 h-8 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors shadow-sm">
              <span className="material-symbols-outlined text-xs">settings_suggest</span>
            </button>
          </div>
        </div>
      </div>
	);
};

export default MBSterilizationHeader;
